import { useMemo } from "react";
import { IModalProps, style } from "./AddModal.config";
import { Box, Button, Modal, Typography, styled } from "@mui/material";
import { MenuIcon } from "components/Layout/MainLayout/Sidebar/icons/MenuIcon";

// Labels

const CANCEL_LABEL = "Cancelar";
const ACCEPT_LABEL = "Añadir";

/**
 * Component to render modal to remove elements
 * @param { boolean } open - Flag to know if modal is oppened or not
 * @param { string } title - Modal header to show principal information
 * @param { string | undefined} warningText - Paragraph explanation optional
 * @param { boolean } hideAcceptButton - Flag to hide or not accept button
 * @param { () => void | undefined} onAcceptHandler - Function to execute when user pushes accept button
 * @param { () => void } onCancelHandler - Function to execute when user pushes cancel button
 */

export const AddModal = ({
  open,
  title,
  warningText,
  hideAcceptButton,
  onAcceptHandler,
  onCancelHandler,
  primaryColor,
  secondaryColor,
  children,
}: IModalProps) => {
  const boxJustifyContent = useMemo(
    () => (hideAcceptButton ? "center" : "space-between"),
    [hideAcceptButton]
  );

  return (
    <Modal
      open={open}
      onClose={onCancelHandler}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Box
          display={"flex"}
          gap={"10px"}
          alignItems={"center"}
          sx={{ marginBottom: "1rem" }}
        >
          <div
            style={{
              backgroundColor: "#49AFB838",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "10px",
              borderRadius: "50%",
            }}
          >
            <MenuIcon fill="#49AFB8" />
          </div>

          <Typography align="left" color="secondary" fontWeight={500}>
            {title}
          </Typography>
        </Box>

        {warningText && (
          <Typography
            id="modal-modal-description"
            sx={{ mt: 2, textAlign: "center" }}
          >
            {warningText}
          </Typography>
        )}
        {children}
        <Box
          display="flex"
          justifyContent={boxJustifyContent}
          sx={{ mt: 3, paddingInline: 0 }}
        >
          <CancelButton onClick={onCancelHandler}>{CANCEL_LABEL}</CancelButton>
          {!hideAcceptButton && (
            <Button
              variant="contained"
              color="primary"
              onClick={onAcceptHandler}
              sx={{ width: "216px" }}
            >
              {ACCEPT_LABEL}
            </Button>
          )}
        </Box>
      </Box>
    </Modal>
  );
};

//  Styles modification on cancel button

const CancelButton = styled(Button)(({ theme }) => {
  const secondaryColor = theme.palette.primary.main;
  const whiteColor = "#ffffff";

  return {
    width: "216px",
    backgroundColor: whiteColor,
    color: secondaryColor,
    border: `1px solid ${secondaryColor}`,
    "&:hover": {
      backgroundColor: `${whiteColor} !important`,
      color: secondaryColor,
    },
  };
});
